// useView.ts
// manages user view (in between overview, schedule, accommodation, tora plan)

import { create } from "zustand";

interface ViewStore {
  panel: "locations" | "transport";
  setPanel: (panel: "locations" | "transport") => void;
  activeTab: "overview" | "schedule" | "accommodation" | "tora";
  setActiveTab: (
    tab: "overview" | "schedule" | "accommodation" | "tora"
  ) => void;
}

const useViewStore = create<ViewStore>((set) => ({
  panel: "locations",
  setPanel: (panel) => set({ panel }),
  activeTab: "overview",
  setActiveTab: (tab) => set({ activeTab: tab }),
}));

export default useViewStore;
